var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 15,
    fill: "#491ACB",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 28C12 26.4596 12 25.6893 12.3467 25.1235C12.5407 24.8069 12.8069 24.5407 13.1235 24.3467C13.6893 24 14.4596 24 16 24C17.5404 24 18.3107 24 18.8765 24.3467C19.1931 24.5407 19.4593 24.8069 19.6533 25.1235C20 25.6893 20 26.4596 20 28C20 29.5404 20 30.3107 19.6533 30.8765C19.4593 31.1931 19.1931 31.4593 18.8765 31.6533C18.3107 32 17.5404 32 16 32C14.4596 32 13.6893 32 13.1235 31.6533C12.8069 31.4593 12.5407 31.1931 12.3467 30.8765C12 30.3107 12 29.5404 12 28Z",
    fill: "#491ACB",
    stroke: "#491ACB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C24 26.4596 24 25.6893 24.3467 25.1235C24.5407 24.8069 24.8069 24.5407 25.1235 24.3467C25.6893 24 26.4596 24 28 24C29.5404 24 30.3107 24 30.8765 24.3467C31.1931 24.5407 31.4593 24.8069 31.6533 25.1235C32 25.6893 32 26.4596 32 28C32 29.5404 32 30.3107 31.6533 30.8765C31.4593 31.1931 31.1931 31.4593 30.8765 31.6533C30.3107 32 29.5404 32 28 32C26.4596 32 25.6893 32 25.1235 31.6533C24.8069 31.4593 24.5407 31.1931 24.3467 30.8765C24 30.3107 24 29.5404 24 28Z",
    fill: "#491ACB",
    stroke: "#491ACB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C12 14.4596 12 13.6893 12.3467 13.1235C12.5407 12.8069 12.8069 12.5407 13.1235 12.3467C13.6893 12 14.4596 12 16 12C17.5404 12 18.3107 12 18.8765 12.3467C19.1931 12.5407 19.4593 12.8069 19.6533 13.1235C20 13.6893 20 14.4596 20 16C20 17.5404 20 18.3107 19.6533 18.8765C19.4593 19.1931 19.1931 19.4593 18.8765 19.6533C18.3107 20 17.5404 20 16 20C14.4596 20 13.6893 20 13.1235 19.6533C12.8069 19.4593 12.5407 19.1931 12.3467 18.8765C12 18.3107 12 17.5404 12 16Z",
    fill: "#491ACB",
    stroke: "#491ACB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C24 14.4596 24 13.6893 24.3467 13.1235C24.5407 12.8069 24.8069 12.5407 25.1235 12.3467C25.6893 12 26.4596 12 28 12C29.5404 12 30.3107 12 30.8765 12.3467C31.1931 12.5407 31.4593 12.8069 31.6533 13.1235C32 13.6893 32 14.4596 32 16C32 17.5404 32 18.3107 31.6533 18.8765C31.4593 19.1931 31.1931 19.4593 30.8765 19.6533C30.3107 20 29.5404 20 28 20C26.4596 20 25.6893 20 25.1235 19.6533C24.8069 19.4593 24.5407 19.1931 24.3467 18.8765C24 18.3107 24 17.5404 24 16Z",
    fill: "#491ACB",
    stroke: "#491ACB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboard);
export default __webpack_public_path__ + "static/media/active_dashboard.63d4d7545791a0ba97b10c931dcfd68e.svg";
export { ForwardRef as ReactComponent };